import { API_URL_INTEGRACAO_VOALA, URL_BASE_VOALA } from 'constants/constants';
import React, { useState } from 'react';
import './RdStation.css';

export default function RdStation() {
  const [clientId, setClentId] = useState('');
  const [clientSecret, setClentSecret] = useState('');
  const [url, setURL] = useState('');
  const [loading, setLoading] = useState(false);
  const [rdStationURL, setRdStationURL] = useState('');

  const handleChange = (event, set) => {
    set(event.target.value);
  };

  const handleSubmit = event => {
    if (!clientId || !clientSecret || !url) {
      alert('Preencha Todos os campos!');
    }
    setLoading(true);
    setRdStationURL('');

    fetch(`${API_URL_INTEGRACAO_VOALA}/Conversao/Auth`, {
      method: 'POST',
      headers: { 'Content-type': 'application/json;charset=UTF-8' },
      body: JSON.stringify({
        Callback: url,
        ClientId: clientId,
        ClientSecret: clientSecret,
      }),
    })
      .then(value => value.json())
      .then(json => {
        console.log(json);
        if (json.Data.AutenticarRdStation && json.Data.UrlAutenticarRdStation) {
          setRdStationURL(json.Data.UrlAutenticarRdStation);
        } else {
          window.location.href = json.Data.UrlVoala;
        }
        setLoading(false);
      })
      .catch(e => {
        alert('Aconteceu algum erro!');
        setLoading(false);
      });

    event.preventDefault();
  };

  return (<div className="RdStation">
      <form onSubmit={handleSubmit} >
        <div>
          <label>Client ID</label>
          <input
            type="text"
            name="client_id"
            value={clientId}
            onChange={e => handleChange(e, setClentId)}
          />
        </div>
        <div>
          <label>Client Secret</label>
          <input
            type="text"
            name="client_secret"
            value={clientSecret}
            onChange={e => handleChange(e, setClentSecret)}
          />
        </div>
        <div>
          <label>URL Callback</label>
          <textarea name="url" value={url} onChange={e => handleChange(e, setURL)} />
        </div>
        <input type="submit" className="btn" value="Enviar" />
      </form>

      {rdStationURL !== '' && (
        <div>
          Click no link abaixo para atenticação no RdStation:
          <br />
          <br />
          <a target="_blank" href={rdStationURL}>
            Link RdStation
          </a>
        </div>
      )}
    </div>
  );
}
